export function buildSectionPill(label) {
  return `<span class="section-pill"><span class="section-pill__icon" aria-hidden="true"></span>${label}</span>`;
}

export function buildSectionPillRow(label) {
  return `
    <div class="section-pill-row">
      <span class="section-pill-row__line" aria-hidden="true"></span>
      ${buildSectionPill(label)}
      <span class="section-pill-row__line" aria-hidden="true"></span>
    </div>
  `;
}
